import { useMessageStore } from "@/state/stores";
import { useShallow } from "zustand/react/shallow";

/**
 * Hook that checks if any message is currently being generated
 * @returns true if any message is currently being generated
 */
export function useIsMessageGenerating() {
  const isProcessingMessage = useMessageStore(
    useShallow((state) => {
      return state.messages.some((message) => {
        return message.status === "pending" || message.status === "processing";
      });
    }),
  );
  return isProcessingMessage;
}
